/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function addProducToCart(variantId) {
  let id = variantId;
  let formData = {
    'items': [
      {
        'id': id,
        'quantity': 1
      }
    ]
  };
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((resp) => { 
    return resp.json();
  })
  .then((data) => {
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: id,
          quantity: 1
        }
      }));
  })
  .catch((err) => {
    console.error('Error: ' + err);
  });
}

function addUpsellToCart(target) {
  addProducToCart(target.getAttribute('data-variant-id'));
}

//AJAX COLLECTION
let add_collect = async() => {
    document.querySelectorAll("button.ad_to_cart_coll").forEach((item,index)=>{
      item.addEventListener('click',function(e){
        let that = this;
        e = e || window.event;
        e.preventDefault();
        addProducToCart(this.getAttribute('data-var_id'));
  });
  });
};

/*
let add_collect = async() => {
    document.querySelectorAll("button.ad_to_cart_coll").forEach((item,index)=>{
      item.addEventListener('click',function(e){
        let that = this;
        e = e || window.event;
        e.preventDefault();
        let id = this.getAttribute('data-var_id');
        let formData = {
          'items': [
            {
              'id': id,
              'quantity': 1
            }
          ]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then((resp) => { 
          return resp.json();
        })
        .then((data) => {
         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          //document.querySelector("a#panier_icon_ajax").dispatchEvent(new Event('click', { 'bubbles': true }));
          that.innerHTML="Produit ajouté";
          setTimeout(()=>{that.innerHTML="Ajouter au panier";}, 1700);

        })
        .catch((err) => {
          console.error('Error: ' + err);
        })
    });

  });
};
*/
add_collect();





